// import LinkComponent from '@Components/Link';
import _ from "lodash";
import React from "react";
import {
  documentToReactComponents,
  Options,
} from "@contentful/rich-text-react-renderer";
import { BLOCKS, MARKS } from "@contentful/rich-text-types";

// const embedCmsComponent = (node) => {
//   const contentTypeId = node?.data?.target?.sys?.contentType?.sys?.id;
//   const cmsContent = node?.data?.target?.fields;

//   return contentTypeId ? <CmsContent contentTypeId={contentTypeId} fields={cmsContent} /> : null;
// };

const getOptions = () => {
  /**
   * Refer Available rich text types in @link:https://www.npmjs.com/package/@contentful/rich-text-react-renderer
   */
  return {
    renderMark: {
      [MARKS.BOLD]: (text: string) => <b>{text}</b>,
      [MARKS.ITALIC]: (text: string) => <i>{text}</i>,
      [MARKS.UNDERLINE]: (text: string) => <u>{text}</u>,
      [MARKS.CODE]: (text: string) => <code>{text}</code>,
    },
    renderNode: {
      [BLOCKS.DOCUMENT]: (_node: any, children: any) => children,
      [BLOCKS.HEADING_1]: (_node: any, children: string) => <h1>{children}</h1>,
      [BLOCKS.HEADING_2]: (_node: any, children: string) => <h2>{children}</h2>,
      [BLOCKS.HEADING_3]: (_node: any, children: string) => <h3>{children}</h3>,
      [BLOCKS.HEADING_4]: (_node: any, children: string) => <h4>{children}</h4>,
      [BLOCKS.HEADING_5]: (_node: any, children: string) => <h5>{children}</h5>,
      [BLOCKS.PARAGRAPH]: (_node: any, children: string) => <p>{children}</p>,

      // [BLOCKS.EMBEDDED_ASSET]: (node) => {
      //   const contentType = node?.data?.target?.fields?.file?.contentType;
      //   const fileUrl = node?.data?.target?.fields?.file?.url;

      //   // Note:- Plain Assets will not have any rrsWrapper
      //   // Handle Images
      //   // if (fileUrl && contentType) {
      //   //   if (contentType.match(PATTERNS.MIME_TYPE_IMAGE)) {
      //   //     return <Image src={fileUrl} alt={node?.data?.target?.fields?.title} />;
      //   //   }
      //   //   // Handle Video files
      //   //   else if (contentType.match(PATTERNS.MIME_TYPE_VIDEO)) {
      //   //     return <CmsVideo video={node?.data?.target} />;
      //   //   } else {
      //   //     return <a href={fileUrl}>{node?.data?.target?.fields?.title ?? ''}</a>;
      //   //   }
      //   // }
      // },
      // // [BLOCKS.EMBEDDED_ENTRY]: (node) => embedCmsComponent(node),
      // // [INLINES.EMBEDDED_ENTRY]: (node) => embedCmsComponent(node),
      // [INLINES.HYPERLINK]: (node, children) => {
      //   return <LinkComponent href={node?.data?.uri}>{children}</LinkComponent>;
      // },
      // [INLINES.ASSET_HYPERLINK]: (node, children) => {
      //   return <a href={node?.data?.target?.fields?.file?.url}>{children}</a>;
      // },
      // [INLINES.ENTRY_HYPERLINK]: (node, children) => {
      //   return <LinkComponent href={node?.data?.target?.fields?.slug}>{children}</LinkComponent>;
      // },
    },
    renderText: (text: string) => {
      /* istanbul ignore next */
      return text
        .replace(/ /g, " ")
        .split("\n")
        ?.reduce?.((children: any, textSegment, index) => {
          return [...children, index > 0 && <br key={index} />, textSegment];
        }, []);
    },
  };
};

/**
 * Component - CmsTextEditorContent
 * Uses RichTextEditor
 * @param {object} content - Content to render
 * @returns
 */
const CmsTextEditorContent = ({
  content,
  options,
}: {
  content: any;
  options?: any;
}) => {
  const blocks = content?.json;

  if (!blocks) return null;
  let defaultOptions = getOptions();
  // override options if passed with lodash
  if (options) {
    defaultOptions = _.merge(defaultOptions, options);
  }

  return documentToReactComponents(
    blocks,
    defaultOptions as Options | undefined
  ) as JSX.Element | JSX.Element;
};

export default CmsTextEditorContent;
